import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Provider as UrqlProvider } from 'urql';
import './index.css';
import { graphqlClient } from './lib/graphql';
import { capturePageView, initPostHog } from './lib/posthog';
import { routeTree } from './routeTree.gen';
import { mantineTheme } from './theme';

initPostHog();

const router = createRouter({ routeTree });

router.subscribe('onResolved', () => capturePageView());

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <UrqlProvider value={graphqlClient}>
        <MantineProvider theme={mantineTheme} defaultColorScheme="auto">
          <ModalsProvider>
            <Notifications />
            <RouterProvider router={router} />
          </ModalsProvider>
        </MantineProvider>
      </UrqlProvider>
    </StrictMode>,
  );
}
